import React, { useState, useEffect } from 'react';
import PropTypes, { any } from 'prop-types';

import InfoButton from '../../../InfoButton';
import { SupportLink, VerifiedRulesLink, HighSchoolVerifiedRulesLink } from '../../../Links';
import Tip from '../../../Tip';
import {
    Select,
} from '../../../Form';
import { titles } from '../../../PopUps/VerificationApplicationPopUp';
import { VerificationApplicationPopUp } from '../../../PopUps';
import Popup from '../../../Popup';
import { ClubTierTypes } from '../../../../utils/clubs';
import { EventHsTypes, ballTypeValues, EventVerifiedTypes, sportTypeIds } from '../../../../utils/eventConstants';
import { minimumVerifiedParticipants } from '../../../../utils/constants';
import { hasDinglesDivisions, validateVerifiedEvent } from '../Divisions/divisionValidation';
import { errorMessage } from '../../../../utils/displayMessageConstants';

import styles from '../eventCreate.scss';

const SelectVerified = (props) => {
    const {
        field,
        value,
        formApi,
        editing,
        user,
        verifiedAllowed,
        verifiedPending,
        applyForVerified,
        verificationApplied,
        onChange,
        showTip,
        clubTierType,
        disabled,
        openModal,
        hideVideo,
        isTemplate,
        canUpgradeToPerformanceHs,
    } = props;

    const [showApplicationPopup, setShowApplicationPopup] = useState(false);
    const [showPendingPopup, setShowPendingPopup] = useState(false);
    const [applicationSubmitting, setApplicationSubmitting] = useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [dinglesVerifiedError, setDinglesVerifiedError] = useState(null);
    const verifiedFalse = '1';
    const verifiedTrue = '2';

    const handleVerifiedTrueSelection = (val) => {
        setDinglesVerifiedError(null);

        if (clubTierType.isHighSchool) {
            if (verifiedAllowed) {
                formApi.setValue(field, val);
            } else {
                setShowApplicationPopup(true);
            }
            return;
        }

        if (verifiedAllowed) {
            setShowApplicationPopup(true);
            return;
        }

        if (!formApi.values[field]) {
            formApi.setValue('agreedToVerifiedTerms', false);
        }

        if (formApi.values.agreedToVerifiedTerms) {
            return;
        }

        if (verifiedPending) {
            setShowPendingPopup(true);
        } else {
            setShowApplicationPopup(true);
        }
    };

    const verifiedCheck = (val) => {
        if (val === verifiedFalse) {
            setDinglesVerifiedError(null);
            formApi.setValue(field, val);
            handleVerifiedChangesForBallType(val);
            return;
        }

        const eventDivisions = formApi.values.eventDivisions || [];
        if (hasDinglesDivisions(eventDivisions)) {
            setDinglesVerifiedError(errorMessage.dinglesVerifiedErrorMessage);
            formApi.setValue(field, verifiedFalse);
            return;
        }

        handleVerifiedTrueSelection(val);

        if (onChange) {
            onChange(val);
        }

        handleVerifiedChangesForBallType(val);
    };

    const handleVerifiedChangesForBallType = (val) => {
        const eventDivisions = formApi.values.eventDivisions || [];
        if (val === EventVerifiedTypes.Sanctioned.toString() && eventDivisions.length > 0) {
            eventDivisions.forEach((div, i) => {
                if (div?.ballTypeValue && div.ballTypeValue !== ballTypeValues.YELLOW) {
                    formApi.setError(['eventDivisions', i, 'ballTypeValue'], null);
                }
            });
        }

        if (val === EventVerifiedTypes.UnVerified.toString() && eventDivisions.length > 0) {
            eventDivisions.forEach((div, i) => {
                if (div?.ballTypeValue && div.ballTypeValue !== ballTypeValues.YELLOW) {
                    formApi.setError(['eventDivisions', i, 'ballTypeValue'], errorMessage.ballTypeValueErrorMessage);
                }
            });
        }
    };

    useEffect(() => {
        if (!isTemplate && !editing && !verificationApplied) {
            verifiedCheck(value);
        }
    }, []);

    const getVerifiedEventApplicationData = (sportTypeId) => {
        if (parseInt(sportTypeId) === sportTypeIds.PICKLEBALL) {
            return titles.VERIFIED_EVENT_APPLICATION_FOR_PICKLEBALL;
        }
        return titles.VERIFIED_EVENT_APPLICATION;
    };

    const getVerifiedClubApplicationData = (sportTypeId) => {
        if (parseInt(sportTypeId) === sportTypeIds.PICKLEBALL) {
            return titles.VERIFIED_CLUB_APPLICTAION_EVENT_FLOW_FOR_PICKLEBALL;
        }
        return titles.VERIFIED_CLUB_APPLICATION_EVENT_FLOW;
    };

    const getVerifiedApplicationPopUpData = () => {
        if (clubTierType.isHighSchool) {
            return titles.VERIFIED_HS_CLUB_APPLICTAION_EVENT_FLOW;
        }
        return verifiedAllowed ? getVerifiedEventApplicationData(formApi?.values?.sportTypeId) : getVerifiedClubApplicationData(formApi?.values?.sportTypeId);
    };

    const getStyles = (verifiedAllowed, sportTypeId) => {
        if (verifiedAllowed) {
            if (parseInt(sportTypeId) === sportTypeIds.PICKLEBALL) {
                return { height: '500px' };
            }
            return { height: '600px' };
        }
        return { height: '650px', width: '600px' };
    };

    const applicationForVerified = async () => {
        const { isHighSchool } = clubTierType;
        if (!isHighSchool && formApi) {
            formApi.setValue('agreedToVerifiedTerms', true);
        }

        setApplicationSubmitting(true);
        await applyForVerified(isHighSchool);

        setShowApplicationPopup(false);
        setApplicationSubmitting(false);
        setShowConfirmationPopup(!isHighSchool);
        if (onChange) {
            onChange(formApi.values[field]);
        }

        if (user.id) {
            window.open(`https://universaltennis.typeform.com/to/dJbjyp?ID=${user.id}`, '_blank');
        }
    };

    const showUpgradeToPerformanceHsPopup = () => {
        props.showUpgradeToPerformanceHsPopup();
    };

    const showUpgradeToPerforanceHs = clubTierType.isHighSchool &&
        clubTierType.id === ClubTierTypes.HIGH_SCHOOL &&
        formApi.values?.hsEventType === EventHsTypes.OTHER &&
        canUpgradeToPerformanceHs;
    const getTipContent = () => {
        if (showUpgradeToPerforanceHs) {
            return (
                <>
                    <p>Interested in running verified events outside of your high school season?</p>
                    <p>Upgrade to Performance High School by clicking <a href="#" onClick={showUpgradeToPerformanceHsPopup}>here</a>.</p>
                    <p>
                        Verified events can only be run by Verified Event Organizers, Clubs, Colleges, and High Schools and must follow the
                        &nbsp;
                        <VerifiedRulesLink target="_blank">Verified Event Rules</VerifiedRulesLink>
                    </p>
                </>
            );
        }

        return (
            <p>
                Verified events can only be run by Verified Event Organizers, Clubs, Colleges, or High Schools and must follow the
                &nbsp;
                <VerifiedRulesLink target="_blank">Verified Event Rules</VerifiedRulesLink>
            </p>
        );
    };

    const validateEvent = (value) => {
        const eventDivisions = formApi.values.eventDivisions || [];
        return validateVerifiedEvent(value, eventDivisions);
    };

    return (
        <React.Fragment>
            <div className={`col-12 ${showUpgradeToPerforanceHs ? 'mb96' : 'mb24'}`}>
                <div className="div div16" />
                <Tip
                    variant="info"
                    isComponent={true}
                    content={getTipContent()}
                    showTip={showTip}
                >
                    <div className={`d-flex align-items-start`}>
                        <div className={`flex-2`}>
                            <div className={`form-group form-group-xl mb0`}>
                                <label htmlFor={'verified'}>
                                    Is this a Verified event?
                                    <InfoButton
                                        hoverText={(clubTierType.isHighSchool
                                            ? (
                                                <>
                                                    <HighSchoolVerifiedRulesLink target="_blank">Learn more</HighSchoolVerifiedRulesLink> about Verified events and results.
                                                </>
                                            ) : (
                                                <>
                                                    Verified events can only be run by Verified Event Organizers, Clubs, Colleges, or High Schools and must follow the <VerifiedRulesLink target="_blank">Verified Event Rules</VerifiedRulesLink>.
                                                </>
                                            )
                                        )}
                                    />
                                </label>
                                {(!hideVideo && parseInt(formApi?.values?.sportTypeId) === sportTypeIds.TENNIS) && (
                                    <div className={`${styles.watchVideo} pb24`}>
                                        <span className={`text-small`} onClick={() => openModal('video2')}>
                                            <i className="fas fa-play" /><span>What is Verified UTR Rating</span>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={`flex-1`}>
                            <Select
                                id="$verified"
                                formGroupCssClass={`mb0`}
                                field={field}
                                value={value}
                                options={[
                                    {
                                        id: '1',
                                        value: '1',
                                        label: 'No',
                                    },
                                    {
                                        id: '2',
                                        value: '2',
                                        label: 'Yes',
                                    },
                                ]}
                                onChange={(val) => {
                                    verifiedCheck(val);
                                    if (onChange) {
                                        onChange(val);
                                    }
                                }}
                                validate={value => validateEvent(value)}
                                hiddenLabel={true}
                                disabled={disabled}
                            />
                            {dinglesVerifiedError && (
                                <p
                                    className="text-danger text-small mt8"
                                    data-testid="event-create.step1.verified.dingles-error"
                                >
                                    {dinglesVerifiedError}
                                </p>
                            )}
                        </div>
                    </div>
                </Tip>
            </div>
            {showApplicationPopup && (
                <VerificationApplicationPopUp
                    data={getVerifiedApplicationPopUpData()}
                    showLoader={true}
                    onCloseClick={() => {
                        if (formApi) {
                            if (verifiedAllowed) {
                                formApi.setValue(field, verifiedTrue);
                                if (onChange) {
                                    onChange(verifiedTrue);
                                }
                            } else {
                                formApi.setValue('agreedToVerifiedTerms', false);
                                formApi.setValue(field, verifiedFalse);
                            }
                        }
                        setShowApplicationPopup(false);
                    }}
                    onCtaClick={applicationForVerified}
                    submittingApplication={applicationSubmitting}
                    style={clubTierType.isHighSchool ? { height: '624px' } : getStyles(verifiedAllowed, parseInt(formApi?.values?.sportTypeId))}
                />
            )}
            {showPendingPopup && (
                <Popup
                    className="popup-sm"
                    onCloseClick={() => {
                        setShowPendingPopup(false);
                    }}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        style: {
                            height: parseInt(formApi?.values?.sportTypeId) === sportTypeIds.PICKLEBALL ? '550px' : '650px',
                        },
                        scrollable: true,
                    }}
                >
                    <div className="popup-section p24 pt0 pb0">
                        <h5>Your Verified Club Application is Pending!</h5>
                        <h5 className="text-gray">You can publish the event once approved.</h5>
                    </div>
                    <div className="popup-section p24 text-dark">
                        <p>Each Verified Tournament must have:</p>
                        <ul>
                            <li>Clear Scheduling/Registration</li>
                            <li>Minimum of {`${minimumVerifiedParticipants}`} participants</li>
                            {parseInt(formApi?.values?.sportTypeId) === sportTypeIds.TENNIS && (
                                <>
                                    <li>Singles format: 2/3 regular or 2/3 FAST4 Sets</li>
                                    <li>Doubles format: 2/3 regular, 8-game pro or regular set</li>
                                </>
                            )}
                            <li>A Tournament Official designated to be responsible & accountable for all scores reported and submitted.</li>
                        </ul>
                        <VerifiedRulesLink target="_blank">See all requirements</VerifiedRulesLink>
                        <div className="mt24">
                            <div className="row">
                                <div className={`col-12`}>
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowPendingPopup(false);
                                        }}
                                    >
                                        Got it
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
            {showConfirmationPopup && (
                <Popup
                    className="popup-sm"
                    onCloseClick={() => {
                        setShowConfirmationPopup(false);
                    }}
                    config={{
                        fullScreen: false,
                        noPadding: true,
                        style: {
                            height: '620px',
                        },
                    }}
                >
                    <div className="popup-section p24 pt0">
                        <h5>Thanks! Your application is in review.</h5>
                    </div>
                    <div className="popup-section popup-section-gradient p24 text-center">
                        <i className="utr utr-sanctioned fs136 text-white" />
                    </div>
                    <div className="popup-section p24">
                        <p>Verified events can be published after your application is approved to be a Verified Organizer. Approval usually takes 24-48 hours. We will notify you by email of the outcome of your application review.<br /><br />Have questions about your application? Contact our <SupportLink target="_blank">support team.</SupportLink></p>
                        <div className="mt24">
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="button"
                                        className="btn btn-default btn-default text-uppercase btn-block"
                                        onClick={() => {
                                            setShowConfirmationPopup(false);
                                        }}
                                    >
                                        Continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </React.Fragment>
    );
};

SelectVerified.propTypes = {
    formApi: PropTypes.objectOf(any).isRequired,
    editing: PropTypes.bool,
    onChange: PropTypes.func,
    showTip: PropTypes.bool,
    clubTierType: PropTypes.objectOf(any).isRequired,
    isTemplate: PropTypes.bool,
    hideVideo: PropTypes.bool,
    canUpgradeToPerformanceHs: PropTypes.bool,
    verifiedAllowed: PropTypes.bool,
    verifiedPending: PropTypes.bool,
    applyForVerified: PropTypes.func,
    verificationApplied: PropTypes.bool,
};

SelectVerified.defaultProps = {
    editing: false,
    onChange: () => { },
    showTip: false,
    isTemplate: false,
    hideVideo: false,
    canUpgradeToPerformanceHs: false,
    verifiedAllowed: false,
    verifiedPending: false,
    applyForVerified: () => { },
    verificationApplied: false,
};

export default SelectVerified;
